import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './responsive.css';
import './intersection.css';
import Home from './components/Home'
import Footer from './components/Footer'

// New BusinessPlan component import
import BusinessPlan from './components/BusinessPlan';

import Partner from './components/Partner';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import CopyrightPolicy from './components/CopyrightPolicy';
import OnItsWay from './components/OnWay';

function App() {

    useEffect(() => {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        };
    
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
            } else {
              entry.target.classList.remove('in-view');
            }
          });
        }, options);
    
        const elements = document.querySelectorAll('.appear, .phoneScroll, .appearLeft, .appearRight, .appearBottom, .appearTop');
        elements.forEach((element) => observer.observe(element));
    
        return () => {
          observer.disconnect();
        };
      }, []);

    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/partner" element={<Partner />} />
                    <Route path="/plan" element={<BusinessPlan />} />
                    <Route path="/termsandconditions" element={<TermsAndConditions />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                    <Route path="/copyright" element={<CopyrightPolicy />} />
                    <Route path="/onitsway" element={<OnItsWay />} />
                </Routes>
                <Footer/>
            </div>
        </Router>
    );
}

export default App;